// @ts-nocheck
import { initialState } from './reducer';

const orderExplainerSelector = (state) => state['model/orderExplainer'] || initialState;

export const getOrderExplanation = (state, orderDetailId: number | string) => {
	return orderExplainerSelector(state)?.data?.[orderDetailId] || null;
};

export const getOrderExplanationLoading = (state, orderDetailId: number | string) => {
	return orderExplainerSelector(state)?.loading?.[orderDetailId] || false;
};

export const getOrderExplanationError = (state, orderDetailId: number | string) => {
	return orderExplainerSelector(state)?.error?.[orderDetailId] || null;
};

